import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MENU_CONFIG } from '../../core/config/menu.config';
import { MenuStructure } from '../../core/models/menu.models';
import { BreakpointFacadeService } from '../../shared/services/breakpoint.facade.service';
import { BreakpointService } from '../../shared/services/breakpoint.service';

@Component({
  selector: 'app-layout-shell',
  templateUrl: './layout-shell.component.html',
  styleUrls: ['./layout-shell.component.scss'],
  standalone: false,
})
export class LayoutShellComponent implements OnInit, OnDestroy {
  sidebarOpen = true;
  sidebarMode: 'side' | 'over' = 'side';
  menuConfig: MenuStructure = MENU_CONFIG;

  private destroy$ = new Subject<void>();

  constructor(
    private breakpointService: BreakpointService,
    private breakpointFacade: BreakpointFacadeService,
  ) {}

  ngOnInit(): void {
    this.breakpointService.Size().pipe(takeUntil(this.destroy$)).subscribe();

    this.breakpointFacade.size$.pipe(takeUntil(this.destroy$)).subscribe((size) => {
      if (size === 'XSmall' || size === 'Small') {
        this.sidebarOpen = false;
        this.sidebarMode = 'over';
      } else {
        this.sidebarOpen = true;
        this.sidebarMode = 'side';
      }
    });
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
